export const getSuffix = (number, type) => {
    let suffix = [];
    if (number > 10 && number < 21) {
        suffix = {
            year: 'лет',
            minute: 'минут',
            specialist: 'опытных специалистов',
            point: 'баллов'
        }
    } else {
        switch (number % 10) {
            case 1:
                suffix = {
                    year: 'год',
                    minute: 'минута',
                    specialist: 'опытный специалист',
                    point: 'балл'
                };
                break;
            case 2:
            case 3:
            case 4:
                suffix = {
                    year: 'года',
                    minute: 'минуты',
                    specialist: 'опытных специалиста',
                    point: 'балла'
                }
                break;
            default:
                suffix = {
                    year: 'лет',
                    minute: 'минут',
                    specialist: 'опытных специалистов',
                    point: 'баллов'
                };
        }
    }
    return suffix[type];
}

export const getAgesSuffix = (number) => {
    return getSuffix(number, 'year');
}

export const getSpecialistSuffix = (number) => {
    return getSuffix(number, 'specialist');
}

export const getPointSuffix = (number) => {
    return getSuffix(number, 'point');
}
